var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.06,15.39h8.96l11.75,32.63,11.7-32.63h9.01v39.94h-6.05v-31.78l-11.41,31.78h-6.56l-11.41-31.78v31.78h-5.99V15.39Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.91,15.39h7.19l15.8,39.94h-6.79l-3.77-9.98h-17.69l-3.77,9.98h-6.73l15.75-39.94ZM84.24,39.58l-6.73-17.69-6.68,17.69h13.41Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.2,21.27h-13.29v-5.88h32.86v5.88h-13.29v34.06h-6.28V21.27Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.11,35.53c0-12.78,8.04-21.11,19.63-21.11,9.24,0,16.43,5.25,16.94,14.26h-6.45c-.46-5.42-4.74-8.44-10.73-8.44-7.93,0-13.01,5.71-13.01,15.06,0,8.16,3.94,15.23,12.84,15.23,6.05,0,10.73-3.2,11.07-9.53h6.45c-.51,10.16-8.27,15.35-17.86,15.35-12.89,0-18.88-9.87-18.88-20.82Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.73,15.39h6.22v16.89h19.23V15.39h6.28v39.94h-6.28v-17.17h-19.23v17.17h-6.22V15.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatch);
export default __webpack_public_path__ + "static/media/match.2cb421a2a2ef76e5679c9f016362a289.svg";
export { ForwardRef as ReactComponent };